// assets/delivery-calendar.js

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var containers = document.querySelectorAll('.delivery-calendar');
    if (!containers.length) return;

    containers.forEach(initCalendar);
  });

  /* ===================== Helpers ===================== */

  function parseIntOrNull(value) {
    if (value === undefined || value === null || value === '') return null;
    var n = parseInt(value, 10);
    return isNaN(n) ? null : n;
  }

  function startOfDay(date) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return d;
  }

  function addDays(date, days) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    d.setDate(d.getDate() + days);
    return d;
  }

  function addMonths(date, months) {
    var d = new Date(date.getFullYear(), date.getMonth(), 1);
    d.setMonth(d.getMonth() + months);
    return d;
  }

  function isSameDay(a, b) {
    if (!a || !b) return false;
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function clampDateToMonthRange(date, minDate, maxDate) {
    // Возвращает первую дату месяца, но не раньше minDate и не позже maxDate
    var d = new Date(date.getFullYear(), date.getMonth(), 1);

    var minMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
    var maxMonth = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);

    if (d < minMonth) return minMonth;
    if (d > maxMonth) return maxMonth;
    return d;
  }

  function formatDateLong(date) {
    if (!date) return '';
    return date.toLocaleDateString(undefined, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  }

  function formatDateShort(date) {
    if (!date) return '';
    return date.toLocaleDateString(undefined, {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  }

  /**
   * Shopify money formatter
   * cents: integer, e.g. 12345 = 123.45
   */
  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';

    // 1) money format из глобальной конфигурации виджета
    var formatString =
      (window.DELIVERY_CALENDAR_CONFIG &&
        window.DELIVERY_CALENDAR_CONFIG.money_format) ||
      (window.theme && window.theme.moneyFormat) ||
      '${{amount}}';

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return '';
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    var match = formatString.match(placeholderRegex);
    var value = '';

    if (match && match[1]) {
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }

    // fallback
    return '$' + (cents / 100).toFixed(2);
  }

  /* ===================== Main init ===================== */

  function initCalendar(container) {
    var today = startOfDay(new Date());

    // ----- DOM references -----
    var monthLabelEl = container.querySelector('.delivery-calendar__month');
    var weekdaysRowEl = container.querySelector('.delivery-calendar__weekdays');
    var gridEl = container.querySelector('.delivery-calendar__grid');
    var selectedEl = container.querySelector('.delivery-calendar__selected');
    var windowInfoEl = container.querySelector(
      '.delivery-calendar__window-info'
    );
    var pricingEl = container.querySelector('.delivery-calendar__pricing');
    var depositSection = container.querySelector('.delivery-calendar__deposit');
    var depositCheckbox = container.querySelector(
      '.delivery-calendar__deposit-toggle'
    );
    var legendEl = container.querySelector('.delivery-calendar__legend');
    var prevBtn = container.querySelector('.delivery-calendar__nav--prev');
    var nextBtn = container.querySelector('.delivery-calendar__nav--next');

    // product form + add to cart
    var productFormWrapper =
      container.closest('product-form') ||
      container.closest('form[action^="/cart/add"]');
    if (!productFormWrapper) return;

    var productForm = productFormWrapper.tagName.toLowerCase() === 'form'
      ? productFormWrapper
      : productFormWrapper.querySelector('form');

    var addButton =
      productFormWrapper.querySelector('button[name="add"]') ||
      productFormWrapper.querySelector('button[type="submit"]');

    if (!productForm || !addButton) return;

    function getCurrentVariantId() {
      var input = productForm.querySelector('input[name="id"]');
      return input ? input.value : null;
    }

    // ----- Data attributes -----
    var basePriceCents = parseIntOrNull(container.dataset.basePrice);
    var depositVariantId = container.dataset.depositVariantId || null;
    var depositPriceCents = parseIntOrNull(container.dataset.depositPrice);

    var fastUpgradeVariantId = container.dataset.fastUpgradeVariantId || null;
    var fastUpgradePriceCents = parseIntOrNull(
      container.dataset.fastUpgradePrice
    );

    var lightningUpgradeVariantId =
      container.dataset.lightningUpgradeVariantId || null;
    var lightningUpgradePriceCents = parseIntOrNull(
      container.dataset.lightningUpgradePrice
    );

    var seaUpgradeVariantId = container.dataset.seaUpgradeVariantId || null;
    var seaUpgradePriceCents = parseIntOrNull(
      container.dataset.seaUpgradePrice
    );

    var productTitle = container.dataset.productTitle || '';

    // Метаполя-окна: offsets от сегодня
    var standardStartOffset = parseIntOrNull(
      container.dataset.standardStartOffsetDays
    );
    var standardEndOffset = parseIntOrNull(
      container.dataset.standardEndOffsetDays
    );
    var fastStartOffset = parseIntOrNull(container.dataset.fastStartOffsetDays);
    var fastEndOffset = parseIntOrNull(container.dataset.fastEndOffsetDays);
    var lightningStartOffset = parseIntOrNull(
      container.dataset.lightningStartOffsetDays
    );
    var lightningEndOffset = parseIntOrNull(
      container.dataset.lightningEndOffsetDays
    );
    var seaStartOffset = parseIntOrNull(container.dataset.seaStartOffsetDays);
    var seaEndOffset = parseIntOrNull(container.dataset.seaEndOffsetDays);

    // Если стандарт не задан, используем дефолт 40–200 дней
    if (standardStartOffset === null && standardEndOffset === null) {
      standardStartOffset = 40;
      standardEndOffset = 200;
    }

    // Конфиг окон
    var windowsConfig = {
      standard: {
        key: 'standard',
        label: 'Standart build',
        cssModifier: 'standard',
        startOffset: standardStartOffset,
        endOffset: standardEndOffset,
        surchargeCents: 0
      },
      fast: {
        key: 'fast',
        label: 'Priority build',
        cssModifier: 'fast',
        startOffset: fastStartOffset,
        endOffset: fastEndOffset,
        surchargeCents: fastUpgradePriceCents || 0
      },
      lightning: {
        key: 'lightning',
        label: 'Rush build',
        cssModifier: 'lightning',
        startOffset: lightningStartOffset,
        endOffset: lightningEndOffset,
        surchargeCents: lightningUpgradePriceCents || 0
      },
      sea: {
        key: 'sea',
        label: 'Batch build (sea freight)',
        cssModifier: 'sea',
        startOffset: seaStartOffset,
        endOffset: seaEndOffset,
        surchargeCents: seaUpgradePriceCents || 0
      }
    };

    // Рассчитываем абсолютные даты окон
    Object.keys(windowsConfig).forEach(function (key) {
      var cfg = windowsConfig[key];
      if (
        cfg.startOffset === null ||
        cfg.endOffset === null ||
        isNaN(cfg.startOffset) ||
        isNaN(cfg.endOffset)
      ) {
        cfg.active = false;
        cfg.startDate = null;
        cfg.endDate = null;
        return;
      }
      cfg.active = true;
      cfg.startDate = addDays(today, cfg.startOffset);
      cfg.endDate = addDays(today, cfg.endOffset);
    });

    // Набор активных окон
    var windowOrder = ['lightning', 'fast', 'standard', 'sea'];
    var activeWindows = windowOrder.filter(function (key) {
      return windowsConfig[key] && windowsConfig[key].active;
    });

    if (!activeWindows.length) {
      // Если вообще нет ни одного окна — просто выходим
      return;
    }

    // Границы календаря
    var minDate = null;
    var maxDate = null;
    activeWindows.forEach(function (key) {
      var cfg = windowsConfig[key];
      if (!minDate || cfg.startDate < minDate) minDate = cfg.startDate;
      if (!maxDate || cfg.endDate > maxDate) maxDate = cfg.endDate;
    });

    minDate = startOfDay(minDate);
    maxDate = startOfDay(maxDate);

    // Текущее состояние
    var currentMonth = clampDateToMonthRange(today, minDate, maxDate);
    currentMonth.setDate(1);

    var selectedDate = null;
    var selectedWindowKey = null;

    /* ========== Weekdays header (Mon–Sun) ========== */

    if (weekdaysRowEl) {
      var weekdayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      weekdaysRowEl.innerHTML = '';
      weekdayLabels.forEach(function (label) {
        var span = document.createElement('span');
        span.textContent = label;
        weekdaysRowEl.appendChild(span);
      });
    }

    /* ========== Legend pills (аннотация по цветам) ========== */

    if (legendEl) {
      legendEl.innerHTML = '';
      windowOrder.forEach(function (key) {
        var cfg = windowsConfig[key];
        if (!cfg || !cfg.active) return;

        var item = document.createElement('div');
        item.className = 'delivery-calendar__legend-item';
        item.dataset.window = key;

        var dot = document.createElement('span');
        dot.className =
          'delivery-calendar__legend-dot delivery-calendar__legend-dot--' +
          cfg.cssModifier;

        var text = document.createElement('span');
        // Текст можно менять тут, если нужно другие формулировки
        if (key === 'standard') {
          text.textContent = 'Standart build';
        } else if (key === 'fast') {
          text.textContent = 'Priority build';
        } else if (key === 'lightning') {
          text.textContent = 'Rush build';
        } else if (key === 'sea') {
          text.textContent = 'Sea batch';
        } else {
          text.textContent = cfg.label;
        }

        item.appendChild(dot);
        item.appendChild(text);
        legendEl.appendChild(item);
      });
    }

    /* ========== Calendar rendering ========== */

    function getWindowForDate(date) {
      // Приоритет: lightning → fast → standard → sea
      for (var i = 0; i < windowOrder.length; i++) {
        var key = windowOrder[i];
        var cfg = windowsConfig[key];
        if (!cfg.active) continue;
        if (date >= cfg.startDate && date <= cfg.endDate) {
          return key;
        }
      }
      return null;
    }

    function renderCalendar() {
      if (!gridEl) return;

      gridEl.innerHTML = '';

      // Заголовок месяца
      if (monthLabelEl) {
        var monthLabel = currentMonth.toLocaleDateString(undefined, {
          month: 'long',
          year: 'numeric'
        });
        monthLabelEl.textContent = monthLabel;
      }

      var year = currentMonth.getFullYear();
      var month = currentMonth.getMonth();
      var firstOfMonth = new Date(year, month, 1);
      var lastOfMonth = new Date(year, month + 1, 0);

      // Сдвиг для понедельника как первого дня недели
      var jsDay = firstOfMonth.getDay(); // 0=Sun..6=Sat
      var offset = (jsDay + 6) % 7; // 0=Mon..6=Sun

      // Пустые слоты до 1-го числа
      for (var i = 0; i < offset; i++) {
        var empty = document.createElement('div');
        empty.className = 'delivery-calendar__day is-disabled';
        empty.textContent = '';
        gridEl.appendChild(empty);
      }

      // Дни месяца
      for (var day = 1; day <= lastOfMonth.getDate(); day++) {
        (function (d) {
          var dateObj = new Date(year, month, d);
          var date = startOfDay(dateObj);

          var button = document.createElement('button');
          button.type = 'button';
          button.textContent = String(d);
          button.className = 'delivery-calendar__day';

          // Вне глобального диапазона
          if (date < minDate || date > maxDate) {
            button.classList.add('is-disabled');
            gridEl.appendChild(button);
            return;
          }

          var windowKey = getWindowForDate(date);
          if (!windowKey) {
            button.classList.add('is-disabled');
            gridEl.appendChild(button);
            return;
          }

          var cfg = windowsConfig[windowKey];
          if (cfg && cfg.cssModifier) {
            button.classList.add(
              'delivery-calendar__day--' + cfg.cssModifier
            );
          }

          if (selectedDate && isSameDay(date, selectedDate)) {
            button.classList.add('is-selected');
            // важно: текст остаётся из CSS, не красим в белый
            button.style.color = '';
          }

          button.addEventListener('click', function () {
            if (button.classList.contains('is-disabled')) return;
            selectedDate = date;
            selectedWindowKey = windowKey;
            renderCalendar();
            updateTexts();
          });

          gridEl.appendChild(button);
        })(day);
      }

      // Обновить состояние кнопок навигации
      if (prevBtn) {
        var prevMonth = addMonths(currentMonth, -1);
        var minMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
        prevBtn.disabled = prevMonth < minMonth;
      }
      if (nextBtn) {
        var nextMonth = addMonths(currentMonth, 1);
        var maxMonth = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
        nextBtn.disabled = nextMonth > maxMonth;
      }
    }

    /* ========== Text blocks under calendar ========== */

    function updateTexts() {
      if (!selectedDate || !selectedWindowKey) {
        if (selectedEl) {
          selectedEl.textContent = 'No date selected yet.';
        }
        if (windowInfoEl) {
          windowInfoEl.textContent = '';
        }
        if (pricingEl) {
          pricingEl.textContent = '';
        }
        return;
      }

      var cfg = windowsConfig[selectedWindowKey];

      if (selectedEl) {
        selectedEl.innerHTML =
          'Selected date: <strong>' + formatDateLong(selectedDate) + '</strong>.';
      }

      // Информация по окну
      if (windowInfoEl) {
        var surchargeCents = cfg.surchargeCents || 0;
        var infoHtml =
          'This date falls into the <strong>' +
          cfg.label +
          '</strong> window';

        if (surchargeCents > 0) {
          infoHtml +=
            ' (<strong>' +
            formatMoney(surchargeCents) +
            '</strong> production priority upgrade).';
        } else {
          infoHtml += ' (no extra production fee).';
        }

        windowInfoEl.innerHTML = infoHtml;
      }

      // Цены / депозит
      if (!pricingEl || !basePriceCents) {
        return;
      }

      var totalCents = basePriceCents + (cfg.surchargeCents || 0);
      var useDeposit = depositCheckbox && depositCheckbox.checked;
      var html = '';

      if (!useDeposit || !depositVariantId || !depositPriceCents) {
        // Полная оплата сейчас
        html +=
          'Total for this product in the <strong>' +
          cfg.label +
          '</strong> window: <strong>' +
          formatMoney(totalCents) +
          '</strong>. ';

        if (cfg.surchargeCents && cfg.surchargeCents > 0) {
          html +=
            'This includes a <strong>' +
            formatMoney(cfg.surchargeCents) +
            '</strong> production priority upgrade. ';
        } else {
          html += 'No extra production fee applies. ';
        }

        html += 'You pay this amount at checkout.';
        pricingEl.innerHTML = html;
        return;
      }

      // ----- Режим депозита -----
      var deposit = depositPriceCents;
      var remaining = Math.max(totalCents - deposit, 0);
      var todayPlus7 = addDays(today, 7);
      var finalBeforeDate = addDays(selectedDate, -10);

      html +=
        'Now: you pay a booking deposit of <strong>' +
        formatMoney(deposit) +
        '</strong>. ';

      if (selectedWindowKey === 'standard') {
        // Стандартное окно – делим на 2 платежа + депозит
        if (remaining > 0) {
          var second = Math.round(remaining / 2);
          var third = remaining - second;

          html +=
            'Then you pay <strong>' +
            formatMoney(second) +
            '</strong><strong>' +
            formatDateShort(todayPlus7) +
            '</strong>, and the final <strong>' +
            formatMoney(third) +
            '</strong> 10 days before dispatch ( <strong>' +
            formatDateShort(finalBeforeDate) +
            '</strong>). ';
        }

        html +=
          'Total for this build slot: <strong>' +
          formatMoney(totalCents) +
          '</strong>. You can cancel and get a full refund of the deposit within 7 days.';
      } else {
        // Fast / Lightning / Sea – один платёж после депозита
        if (remaining > 0) {
          html +=
            'The remaining <strong>' +
            formatMoney(remaining) +
            '</strong> is due about 7 days after booking ( <strong>' +
            formatDateShort(todayPlus7) +
            '</strong>) before we start your ' +
            cfg.label.toLowerCase() +
            '. ';
        }

        html +=
          'Total for this build slot: <strong>' +
          formatMoney(totalCents) +
          '</strong>. You can cancel and get a full refund of the deposit within 7 days.';
      }

      pricingEl.innerHTML = html;
    }

    /* ========== Deposit visibility ========== */

    if (!depositVariantId || !depositPriceCents) {
      if (depositSection) {
        depositSection.style.display = 'none';
      }
    } else {
      // По умолчанию чекбокс НЕ включён
      if (depositCheckbox) {
        depositCheckbox.checked = false;
        depositCheckbox.addEventListener('change', function () {
          updateTexts();
        });
      }
    }

    /* ========== Month navigation ========== */

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var prevMonth = addMonths(currentMonth, -1);
        var minMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
        if (prevMonth < minMonth) return;
        currentMonth = prevMonth;
        renderCalendar();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var nextMonth = addMonths(currentMonth, 1);
        var maxMonth = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
        if (nextMonth > maxMonth) return;
        currentMonth = nextMonth;
        renderCalendar();
      });
    }

    /* ========== Add to cart override ========== */

    addButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var variantId = getCurrentVariantId();
      if (!variantId) {
        console.error('delivery-calendar: no variant ID found');
        return;
      }

      if (!selectedDate || !selectedWindowKey) {
        alert('Please choose a delivery date before adding to cart.');
        if (container.scrollIntoView) {
          container.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      var dateISO =
        selectedDate.getFullYear() +
        '-' +
        String(selectedDate.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(selectedDate.getDate()).padStart(2, '0');

      var useDeposit = depositCheckbox && depositCheckbox.checked && depositVariantId;

      var items = [];

      if (useDeposit) {
  // Deposit-only order

  // 1) Take a snapshot of the price text we show under the calendar
  var bookingPriceSnapshot = '';
  // это тот элемент, где у тебя сейчас текст про итоговую сумму
  var pricingSummaryEl = container.querySelector(
    '.delivery-calendar__pricing, .delivery-experience__pricing'
  );

  if (pricingSummaryEl) {
    bookingPriceSnapshot = pricingSummaryEl.textContent
      .replace(/\s+/g, ' ') // убираем лишние переносы/табуляции
      .trim();
  }

  // 2) Добавляем это как line item property
  items.push({
    id: depositVariantId,
    quantity: 1,
    properties: {
      delivery_date: selectedDateISO,
      delivery_window: selectedWindowKey,
      booking_deposit_mode: 'deposit_only',
      reserved_product: productTitle,
      booking_price_snapshot: bookingPriceSnapshot // <- НОВОЕ ПОЛЕ
    }
  });
} else {
        // Полная оплата основного продукта
        var props = {
          delivery_date: dateISO,
          delivery_option: selectedWindowKey,
          payment_plan: 'Full payment at checkout'
        };

        items.push({
          id: variantId,
          quantity: 1,
          properties: props
        });

        // Добавляем upgrade line item для ускоренных окон
        if (selectedWindowKey === 'fast' && fastUpgradeVariantId) {
          items.push({
            id: fastUpgradeVariantId,
            quantity: 1,
            properties: {
              type: 'production_priority_upgrade',
              applied_to_product_variant: variantId,
              production_window: 'fast'
            }
          });
        } else if (
          selectedWindowKey === 'lightning' &&
          lightningUpgradeVariantId
        ) {
          items.push({
            id: lightningUpgradeVariantId,
            quantity: 1,
            properties: {
              type: 'production_priority_upgrade',
              applied_to_product_variant: variantId,
              production_window: 'lightning'
            }
          });
        } else if (selectedWindowKey === 'sea' && seaUpgradeVariantId) {
          items.push({
            id: seaUpgradeVariantId,
            quantity: 1,
            properties: {
              type: 'production_priority_upgrade',
              applied_to_product_variant: variantId,
              production_window: 'sea'
            }
          });
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            throw new Error('Cart request failed');
          }
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error(err);
          alert(
            'Something went wrong while adding this configuration to your cart. Please try again.'
          );
        });
    });

    // ----- Initial render -----
    renderCalendar();
    updateTexts();
  }
})();
